export default "__VITE_ASSET__C6PEtKFQ__"